export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const ROUTES = {
  LANDING: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  SIGNUP_HORSE_OWNER: '/signup/horse-owner',
  SIGNUP_RIDER: '/signup/rider',
  HORSE_OWNER_HOME: '/horse-owner',
  HORSE_OWNER_PROFILE: '/horse-owner/profile',
  HORSE_OWNER_MY_HORSES: '/horse-owner/my-horses',
  HORSE_OWNER_ADD_HORSE: '/horse-owner/add-a-horse',
  HORSE_OWNER_HORSE_DETAIL: '/horse-owner/my-horses/:horseId',
  RIDER_WELCOME: '/signup/rider/welcome',
  HORSE_RIDER_HOME: '/horse-rider',
  RIDER_BROWSE_HORSES: '/horse-rider/browse-horses',
  RIDER_HORSE_DETAIL: '/horse-rider/browse-horses/:horseId',
  RIDER_PROFILES: '/horse-rider/rider-profiles',
  RIDER_NEW_PROFILE: '/horse-rider/rider-profiles/new',
  RIDER_EDIT_PROFILE: '/horse-rider/rider-profiles/:profileId/edit',
  RIDER_MY_EOIS: '/horse-rider/my-eois',
  BOOKING_REQUESTS: '/booking-requests',
  DASHBOARD: '/dashboard',
  ADMIN_APPROVAL: '/admin/approval',
} as const;

export const ADMIN_EMAIL = 'admin@gmail.com';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
} as const;
